import { common } from "./routes/common"
import { parent } from "./routes/parent"
import { profile } from "./routes/profile"
import { products } from "./routes/products"
import { cart } from "./routes/cart"
import { checkout } from "./routes/checkout"
import { invoice } from "./routes/invoice"
import { AGREEMENT_CLIENT_STATIC } from "static/agreementClient"
import { POLICY_STATIC } from "static/policy"
import { AGREEMENT_PARTNER_STATIC } from "@/static/agreementPartner"
import { SHIPPING_RETURNS_POLICY } from "@/static/shippingReturns"
import { AcDocs } from "@academy/components"

const routes = [
  ...parent,
  ...common,
  ...profile,
  ...products,
  ...cart,
  ...checkout,
  ...invoice,
  {
    path: "/privacy",
    name: "privacyPolicy",
    meta: { requiresAuth: false, layout: "Docs", title: "Privacy Policy" },
    props: { pageTitle: "policy-window.privacy-policy", contentStatic: POLICY_STATIC },
    component: AcDocs,
  },
  {
    path: "/agreement-user",
    name: "agreement",
    meta: { requiresAuth: false, layout: "Docs", title: "User Agreement & Terms" },
    props: {
      pageTitle: "agreement.title",
      tabletTitle: "agreement.tabletTitle",
      mobileTitle: "agreement.tabletTitle",
      contentStatic: AGREEMENT_CLIENT_STATIC,
      showContentList: true,
      tabletTitleClasses: [
        "[&_h2]:max-[1024px]:text-[32px]",
        "[&_h2]:max-[767px]:text-[26px]",
        "[&_h2]:max-[767px]:leading-[28px]",
        "max-[767px]:!p-[24px]",
      ],
    },

    component: AcDocs,
  },
  {
    path: "/agreement-partner",
    name: "agreement-partner",
    meta: { requiresAuth: false, layout: "Docs", title: "Partner Agreement and Terms of Service" },
    props: {
      pageTitle: "agreementPartner.title",
      tabletTitle: "agreementPartner.tabletTitle",
      mobileTitle: "agreementPartner.tabletTitle",
      contentStatic: AGREEMENT_PARTNER_STATIC,
      showContentList: true,
      tabletTitleClasses: [
        "[&_h2]:max-[1024px]:text-[32px]",
        "[&_h2]:max-[767px]:text-[26px]",
        "[&_h2]:max-[767px]:leading-[28px]",
        "max-[767px]:!p-[24px]",
      ],
    },
    component: AcDocs,
  },
  {
    path: "/shipping-returns",
    name: "shipping-returns",
    meta: { requiresAuth: false, layout: "Docs", title: "Shipping & Returns Policy" },
    props: {
      pageTitle: "shippingReturnsPolicy.title",
      tabletTitle: "shippingReturnsPolicy.tabletTitle",
      mobileTitle: "shippingReturnsPolicy.tabletTitle",
      contentStatic: SHIPPING_RETURNS_POLICY,
      tabletTitleClasses: [
        "[&_h2]:max-[1024px]:text-[32px]",
        "[&_h2]:max-[767px]:text-[26px]",
        "[&_h2]:max-[767px]:leading-[28px]",
        "max-[767px]:!p-[24px]",
      ],
    },
    component: AcDocs,
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/",
  },
]

export { routes }
